import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=eded2b48&scoped=true&"
import script from "./UploadBox.vue?vue&type=script&lang=js&"
export * from "./UploadBox.vue?vue&type=script&lang=js&"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=eded2b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eded2b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VSpacer})
